<p-confirmDialog></p-confirmDialog>
<h1>Donor Donations List Report</h1>

<p-card styleClass="mb-2">
    <div class="formgrid grid">
        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Fund Code</label>
            <rc-table-filter [filterModel]="filters.FundCodeID.filterModel" (modelChange)="filters.FundCodeID.filterModel = $event" *ngIf="filters.FundCodeID" [showToFilters]="false" />
        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Event</label>
            <rc-table-filter [filterModel]="filters.EventID.filterModel" (modelChange)="filters.EventID.filterModel = $event" *ngIf="filters.FundCodeID" [showToFilters]="false" />
        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Donor Type</label>
            <rc-table-filter [filterModel]="filters.DonorTypeID.filterModel" (modelChange)="filters.DonorTypeID.filterModel = $event" *ngIf="filters.DonorTypeID" [showToFilters]="false" />
        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Fundraiser</label>
            <rc-table-filter [filterModel]="filters.FundraiserID.filterModel" (modelChange)="filters.FundraiserID.filterModel = $event" *ngIf="filters.FundCodeID" [showToFilters]="false" />
        </div>
        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">

            <label>Contribution Type</label>
            <rc-table-filter [filterModel]="filters.ContributionTypeID.filterModel" (modelChange)="filters.ContributionTypeID.filterModel = $event" *ngIf="filters.FundCodeID" [showToFilters]="false" />
        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Donation Source</label>
            <rc-table-filter [filterModel]="filters.DonationSourceID.filterModel" (modelChange)="filters.DonationSourceID.filterModel = $event" *ngIf="filters.FundCodeID" [showToFilters]="false" />
        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>State</label>
            <rc-table-filter [filterModel]="filters.StateID.filterModel" (modelChange)="filters.StateID.filterModel = $event" *ngIf="filters.FundCodeID" [showToFilters]="false" />
        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Begin Date</label>
            <rc-table-filter [filterModel]="filters.DonationDateBegin.filterModel" (modelChange)="filters.DonationDateBegin.filterModel = $event" *ngIf="filters.DonationDateBegin" [showToFilters]="false" />

        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>End Date</label>
            <rc-table-filter [filterModel]="filters.DonationDateEnd.filterModel" (modelChange)="filters.DonationDateEnd.filterModel = $event" *ngIf="filters.DonationDateEnd" [showToFilters]="false" />
        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Amount From</label>
            <rc-table-filter [filterModel]="filters.DonationAmtFrom.filterModel" (modelChange)="filters.DonationAmtFrom.filterModel = $event" *ngIf="filters.DonationAmtFrom" [showToFilters]="false" />
        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Amount To</label>
            <rc-table-filter [filterModel]="filters.DonationAmtTo.filterModel" (modelChange)="filters.DonationAmtTo.filterModel = $event" *ngIf="filters.FundCodeID" [showToFilters]="false" />
        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Donor Id</label>
            <rc-table-filter [filterModel]="filters.DonorID.filterModel" (modelChange)="filters.DonorID.filterModel = $event" *ngIf="filters.FundCodeID" [showToFilters]="false" />
        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Is Deceased</label>
            <rc-table-filter [filterModel]="filters.IsDeceased.filterModel" (modelChange)="filters.IsDeceased.filterModel = $event" *ngIf="filters.FundCodeID" [showToFilters]="false" />
        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Do Not Solicit</label>
            <rc-table-filter [filterModel]="filters.DoNotSolicit.filterModel" (modelChange)="filters.DoNotSolicit.filterModel = $event" *ngIf="filters.FundCodeID" [showToFilters]="false" />
        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Is Bundled</label>
            <rc-table-filter [filterModel]="filters.IsBundled.filterModel" (modelChange)="filters.IsBundled.filterModel = $event" *ngIf="filters.FundCodeID" [showToFilters]="false" />
        </div>

        <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-2">
            <label>Memos</label>
            <rc-table-filter [filterModel]="filters.Memos.filterModel" (modelChange)="filters.Memos.filterModel = $event" *ngIf="filters.FundCodeID" [showToFilters]="false" />
        </div>
    </div>

    <div class="py-2 flex justify-content-end">
        <rc-generic-button 
            label="Clear All"
            id="button-clear-filters"
            iconImg="clear-filter"
            borderStyle="outline"
            (click)="resetFilters()" 
            [classes]="['my-1']" />
        <rc-generic-button 
            label="View Report"
            id="button-search"
            iconImg="search"
            (click)="onSearch()"
            [classes]="['my-1 ml-1']" />
    </div>
</p-card>

<p-card>
    <div class="py-2 flex justify-content-end">
        <p-button 
            label="Export" 
            icon="fa-sharp fa-light fa-download" 
            (onClick)="onExportToExcel()"
            id="button-export" 
            severity="secondary"
            styleClass="my-1" 
            [disabled]="!hasResults"
            class="ml-0"></p-button>
    </div>

    <div style="width: 100%; position: relative; min-height: 22rem;">
        <p-table 
            #resultstable 
            selectionMode="multiple"
            scrollHeight="flex" 
            filter="false"
            styleClass="rc-datatable-outlined"
            [rows]="pagingModel.maxResults"
            [(selection)]="selectedColumns"
            [columns]="selectedColumns" 
            [value]="data"
            [exportHeader]="'customExportHeader'"
            [paginator]="!showLoading && hasResults && data.length > pagingModel.maxResults" 
            [sortField]="pagingModel.sortField" 
            [sortOrder]="pagingModel.sortAsc" 
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            (onPage)="pageChange($event)" 
            [scrollable]="true" 
            [reorderableColumns]="true"
            id="table-data">

            <ng-template pTemplate="caption" style="min-height: 300px"></ng-template>
            <ng-template #defaultTableHeaderTemplate>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        @for (col of columns; track col.columnName ){
                        <th 
                            *ngIf="col.visible"
                            pSortableColumn={{col.columnName}} id="column-{{col.columnName}}"
                            style="vertical-align: top;" 
                            nowrap
                            >
                            <div class="sortable-title">    
                                <div class="column-title" [textContent]="col.displayColumn"></div>
                                <p-sortIcon 
                                    [field]="col.columnName" 
                                    style="cursor: pointer;"
                                    />
                            </div>
                        </th>
                        }
                    </tr>
                    
                    
                </ng-template>
            </ng-template> 

            <!-- [(selection)]="selectedColumns" -->
            <ng-container [ngTemplateOutlet]="defaultTableHeaderTemplate">
            </ng-container>
            
            <ng-template pTemplate="body" let-item let-index="rowIndex" #defaultTableBodyTemplate>

                <tr *ngIf="!showLoading && hasResults">
                    <!-- [class]="getIsChecked(item, itemsChecked) ? 'selected' : ''" -->
                    @for (column of selectedColumns; track column.columnName ){
                    <td *ngIf="column.visible === true">
                        <a [routerLink]="'/vortex/donors/card/'+ getDisplayValue(item, column)" *ngIf="column.columnName === 'DonorID'" [textContent]="getDisplayValue(item, column)"> </a>
                        <span *ngIf="column.columnName !== 'DonorID'" [textContent]="getDisplayValue(item, column)"></span>
                        <!-- {{column|json}} -->
                    </td>
                    }
                    
                </tr>

            </ng-template>
                
        </p-table>
            
        <div *ngIf="showLoading || !hasResults" ngClass="medium loader-wrapper">
            <div *ngIf="showLoading">
                <rc-loading-spinner></rc-loading-spinner>
            </div>
            <td *ngIf="!showLoading && !searchPerformed && !hasResults" colSpan={{selectedColumns.length}} class="text-center no-data-message">
                Please adjust filters and click Search to generate report.
            </td>
            <td *ngIf="!showLoading && searchPerformed && !hasResults" colSpan={{selectedColumns.length}} class="text-center no-data-message">
                No results available. Please adjust filters and try again.
            </td>
        </div>

        <div class="py-2 flex justify-content-end" *ngIf="hasResults">
            <p-button
                [disabled]="!hasResults"
                label="Export"
                icon="fa-sharp fa-light fa-download"
                id="button-export"
                styleClass="my-1"
                severity="secondary"
                (onClick)="onExportToExcel()"
                class="ml-0"></p-button>
        </div>
    </div>
    
</p-card>

<div class="dialog-footer button-group text-right mt-3" *ngIf="showInDialog">

    <button 
        pButton
        label="Cancel"
        class="p-button-secondary"
        (click)="onCancel()"></button>

</div>

<p-toast></p-toast>

<!-- ACTIONS CONFIRM dialog -->
<p-dialog [(visible)]="showConfirmModal" 
    [modal]="true" 
    header="Confirm Action"
    [closable]="false" 
    styleClass="p-confirm-dialog" 
    #actionModal>

    <div>
        <p>Please confirm you would like to {{confirmAction?.toLowerCase()}} your selected items:</p>
        <p class="label">{{selectedListString()}}</p>
    
        <p *ngIf="confirmAction === 'Delete'" class="font-bold">
            {{numberOfItemsSelected > 1 ? "These events" : "This event"}} will no longer be associated with any expenses or donations.
        </p>
    </div>
    <!-- {{lastClicked|json}} -->
    <ng-template pTemplate="footer">
        <rc-generic-button label="Cancel" (click)="showConfirmModal = false" />
        <rc-generic-button label={{confirmAction}} (clickHandler)="performSelectedOperation()" />
    </ng-template>
</p-dialog>
